import React, { Component, PropTypes } from 'react'
import { Field } from 'redux-form'
import { Link } from 'react-router'

import './SignUp.scss'
import InputControl from 'components/InputControl'
import FacebookLoginButton from 'components/FacebookLoginButton'
import MobileNavBar from 'components/MobileNavBar'
import * as qs from 'utils/querystring'

const propTypes = {
  authenticating: PropTypes.bool.isRequired,
  next: PropTypes.string,
  signup: PropTypes.func.isRequired,
  replace: PropTypes.func.isRequired,
  fbLogin: PropTypes.func.isRequired
}

class SignUp extends Component {
  constructor () {
    super()

    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleFBLogin = this.handleFBLogin.bind(this)
  }

  handleSubmit (data) {
    const {
      signup,
      next
    } = this.props

    signup(data, next)
  }

  handleFBLogin (data) {
    const {
      fbLogin,
      next = '/'
    } = this.props

    fbLogin(data, next)
  }

  render () {
    const {
      handleSubmit,
      authenticating,
      next,
      goBack
    } = this.props

    const loginLink = next === '/'
      ? '/login'
      : `/login${qs.stringify({next}, true)}`

    return (
      <div className='SignUp navbar-screen'>
        <MobileNavBar
          leftControl={
            <Link onClick={goBack}>
              <span className='icon-arrow-back' />
            </Link>
          }
          rightControl={<i className='icon-logo' />}
        >
          Regístrate en aliada
        </MobileNavBar>
        <div className='SignUp-content navbar-screen-content'>
          <div className='navbar-screen-container'>
            <div className='SignUp-social'>
              <FacebookLoginButton
                callback={this.handleFBLogin}
                authenticating={authenticating}
                />
            </div>

            <div className='SignUp-separator'>
              <span className='SignUp-separator-line' />
              <span className='SignUp-separator-text'>o si prefieres</span>
              <span className='SignUp-separator-line' />
            </div>

            <form onSubmit={handleSubmit(this.handleSubmit)} className='SignUp-form'>
              <Field
                name='firstName'
                type='text'
                icon='nombre'
                component={InputControl}
                label='Nombre' />

              <Field
                className='SignUp-input'
                name='lastName'
                type='text'
                icon='apellido'
                component={InputControl}
                label='Apellido' />

              <Field
                className='SignUp-input'
                name='email'
                type='text'
                icon='email'
                component={InputControl}
                label='Correo Electrónico' />

              <Field
                className='SignUp-input'
                name='password'
                type='password'
                icon='password'
                component={InputControl}
                label='Contraseña' />

              <Field
                className='SignUp-input'
                name='passwordConfirmation'
                type='password'
                icon='password'
                component={InputControl}
                label='Confirma tu contraseña' />

              <p className='SignUp-disclaimer'>
                Al registrarme acepto los <a href='https://aliada.mx/terminos' target='_blank'>Términos y Condiciones del Servicio</a> y el <a href='https://aliada.mx/privacidad' target='_blank'>Aviso de Privacidad</a>.
              </p>

              <button
                type='submit'
                className='btn btn-lg btn-block btn-primary'
                disabled={authenticating}>
                Regístrate
              </button>
            </form>
            <div className='SignUp-footer'>
              <div>
                <h4>¿Ya tienes cuenta en Aliada?</h4>
              </div>
              <div>
                <Link to={loginLink} className='Signup-loginButton btn btn-lg btn-default btn-block'>Iniciar sesión</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
SignUp.displayName = 'SignUp'
SignUp.propTypes = propTypes

export default SignUp



// WEBPACK FOOTER //
// ./src/screens/App/shared/screens/SignUp/SignUp.js